<template>
  <div class="newsDetailDiv">
    <!-- 节日消息通知 -->
    <div class="newsDetail" id="newsDetailId" v-if="this.newsDetail.type == 2">
      <div class="newsTitle">{{ this.newsDetail.title }}</div>
      <div class="newsDate">{{ this.newsDetail.time }}</div>
      <div class="detail" id="detailId"></div>
    </div>
    <!-- 活动审核通过 -->
    <div class="approvedDiv" v-else-if="this.newsDetail.type == 1">
      <div class="approved" id="approvedId" v-if="this.newsDetail.status == 2">
        <div class="iconDiv">
          <img
            src="../../assets/image/btn_chenggong_nor.png"
            alt="成功"
            class="icon"
          />
        </div>
        <div class="succ">审核通过</div>
        <div class="approvedTitle">
          {{ this.newsDetail.content }}
        </div>
        <div class="approvedDate">{{ this.newsDetail.cre_date }}</div>
        <div class="backBtnDiv">
          <button class="backBtn" @click="back">返回</button>
        </div>
      </div>
      <!-- 活动审核不通过 -->
      <div class="fail" id="failId" v-else-if="this.newsDetail.status == 3">
        <div class="iconDiv">
          <img
            src="../../assets/image/btn_weitongguo_nor.png"
            alt="失败"
            class="icon"
          />
        </div>
        <div class="failed">审核未通过</div>
        <div class="failTitle">
          {{ this.newsDetail.content }}
        </div>
        <div class="failDate">{{ this.newsDetail.cre_date }}</div>
        <div class="backBtnDiv">
          <button class="backBtn" @click="back">返回</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 初始化type == 1，v-if需要初始值
      newsDetail: {
        type: 1,
      },
      mid: this.$route.query.mid || null,
    };
  },
  created() {
    this.getMyNews();
  },
  mounted() {
    // this.getMyNews();
  },
  methods: {
    async getMyNews() {
      const result = await this.$http({
        url: "/messageinfo",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({ mid: this.mid }),
      });
      this.newsDetail = result.data.data;
      if (this.newsDetail.type == 2) {
        document.getElementById("detailId").innerHTML = this.newsDetail.content;
        for (let i = 0; i < document.getElementsByTagName("img").length; i++) {
          document.getElementsByTagName("img")[i].style = "width:100%";
        }
      }
    },
    back() {
      window.history.back(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.newsDetailDiv {
  display: flex;
  justify-content: center;
  .newsDetail {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    margin-top: 20px;
    background-color: white;
    border-radius: 15px;
    .newsTitle {
      margin-top: 20px;
      width: 100%;
      text-align: center;
      white-space: normal;
      font-size: 1.2rem;
      font-weight: bold;
      color: #333333;
    }
    .newsDate {
      text-align: center;
      margin-top: 20px;
      font-size: 1.1rem;
      font-weight: 400;
      color: #999999;
    }
    .detail {
      width: 96%;
    }
  }
  .approvedDiv {
    position: relative;
    width: 100%;
    left: 5%;
    .approved {
      position: relative;
      margin-top: 20px;
      width: 90%;
      height: 70vh;
      background-image: url(../../assets/image/btn_yuyuechenggong_nor.png);
      background-size: 100%, 100%;
      background-repeat: no-repeat, no-repeat;
      .iconDiv {
        position: absolute;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
        width: 20%;
        .icon {
          width: 100%;
        }
      }
      .succ {
        position: absolute;
        top: 26%;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1.3rem;
        font-weight: bold;
        color: #333333;
      }
      .approvedTitle {
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 1.2rem;
        font-weight: bold;
        color: #333333;
      }
      .approvedDate {
        position: absolute;
        top: 42%;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1.2rem;
        font-weight: bold;
        color: #333333;
      }
    }
    .fail {
      position: relative;
      margin-top: 20px;
      width: 90%;
      height: 70vh;
      background-image: url(../../assets/image/btn_yuyuechenggong_nor.png);
      background-size: 100%, 100%;
      background-repeat: no-repeat, no-repeat;
      .iconDiv {
        position: absolute;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
        width: 20%;
        .icon {
          width: 100%;
        }
      }
      .failed {
        position: absolute;
        top: 26%;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1.3rem;
        font-weight: bold;
        color: #333333;
      }
      .failTitle {
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 1.2rem;
        font-weight: bold;
        color: #333333;
      }
      .failDate {
        position: absolute;
        top: 42%;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1.2rem;
        font-weight: bold;
        color: #333333;
      }
    }
  }
}
.backBtnDiv {
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  .backBtn {
    border: 0;
    background: linear-gradient(270deg, #00706E, #00706E);
    color: white;
    width: 100%;
    border-radius: 30px;
    padding: 10px 0;
    font-size: 1.2rem;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newsActive/NewsDetail.vue